import styled from "styled-components"

const ScrollableStyle = styled.div`
  &::-webkit-scrollbar {
    height: 0;
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    margin: 50px 0 50px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0);
    border-radius: 10px;
    box-shadow: rgba(255, 255, 255, 0.3) 0 0 0 1px;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.45);
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.55);
  }
`

export default ScrollableStyle
